var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"p-0",attrs:{"value":_vm.renderedValue,"placeholder":_vm.placeholder,"prepend-icon":"event","readonly":"","clearable":""},on:{"input":_vm.updateStringValue,"click":_vm.openDialog}})}
var staticRenderFns = []

export { render, staticRenderFns }